import { AiOutlineArrowDown } from "react-icons/ai";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../utils";

const MobileScrollCTA = ({ sx, ...props }) => (
  <Flex
    sx={{
      flexDirection: "column",
      alignItems: "center",
      gap: "5px",
      color: "#252525",
      ...sx,
    }}
    {...props}
  >
    <Box>{getLocalizedString("CATALOGUE_DRAG_CTA")}</Box>
    <AiOutlineArrowDown />
  </Flex>
);

export default MobileScrollCTA;
